import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { appRoutesObj } from "src/app.paths";
import NotificationComponent from "./notification-component";

function UserAccountDropdownComponent() {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const [showUserDropdown, setUserDropdown] = useState<boolean>(false);
  return (
    <div
      className={`${
        i18n.language === "ar"
          ? "ml-7 mobile:ml-2 gap-3"
          : "mr-2 mobile:mr-2 gap-9"
      } flex flex-row items-center relative`}
    >
      <NotificationComponent />
      <div
        className={`${
          i18n.language === "ar" ? "flex-row" : "flex-row-reverse"
        } flex items-center gap-2.5 cursor-pointer`}
        onClick={() => {
          setUserDropdown(!showUserDropdown);
        }}
      >
        {" "}
        {showUserDropdown ? (
          <FiChevronUp className={`text-zinc700`} size={24} />
        ) : (
          <FiChevronDown className={` text-zinc700`} size={24} />
        )}
        <div className="mt-1.5 text-xl font-arMedium text-zinc-500 mobile:text-xs">
          {localStorage.getItem("role") === "student"
            ? "Saad saleh"
            : "مدارس النجاح"}
        </div>
      </div>
      {showUserDropdown ? (
        <div
          className={`${
            i18n.language === "ar" ? "left-8" : "right-1"
          } absolute top-9 h-24 w-44 bg-zinc-50 drop-shadow-[0_0px_20px_rgba(0,0,0,0.1)] rounded-lg`}
        >
          <div className="flex flex-col justify-center">
            <div
              className={`${
                i18n.language === "ar" ? "mr-6" : "ml-6"
              } flex h-11 items-center font-arMedium text-sm text-zinc-500 cursor-pointer`}
              onClick={() =>
                navigate(
                  localStorage.getItem("role") === "student"
                    ? appRoutesObj.getParentProfilePath()
                    : appRoutesObj.getSchoolProfilePage()
                )
              }
            >
              {t("userAccountDropdown.component.personalProfile")}
            </div>
            <div
              className={`${
                i18n.language === "ar" ? "mr-6" : "ml-6"
              } flex h-11 items-center font-arMedium text-sm text-secondary-50 cursor-pointer`}
              onClick={() => {
                localStorage.setItem("role", "signedOut");
                navigate(appRoutesObj.getBasePath());
              }}
            >
              {t("app.shared.signout")}
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

export default UserAccountDropdownComponent;
